/**
 * Discharge Module Formatters
 * Re-exports common formatters from Power Reporting and adds discharge-specific helpers
 */

import { VALIDATION_COLORS, STATUS_COLORS } from './constants';

export {
  formatCurrency,
  formatCurrencyWithSymbol,
  formatDate,
  getPowerStatusBadgeInfo,
} from '../../powerreporting/utils/formatters';

/**
 * Get validation badge info for ready/needsProof/blocked status
 * @param {'ready'|'needsProof'|'blocked'} status - Validation status
 * @returns {{ classes: string, label: string }}
 */
export const getValidationBadgeInfo = (status) => {
  const baseClasses = 'inline-flex items-center px-2.5 py-1 qhd:px-3 qhd:py-1.5 4k:px-4 4k:py-2 text-xs qhd:text-sm 4k:text-base font-bold rounded-full text-center';

  switch (status) {
    case 'ready':
      return {
        classes: `${baseClasses} ${VALIDATION_COLORS.ready}`,
        label: 'Ready',
      };
    case 'needsProof':
      return {
        classes: `${baseClasses} ${VALIDATION_COLORS.needsProof}`,
        label: 'Needs Proof',
      };
    case 'blocked':
      return {
        classes: `${baseClasses} ${VALIDATION_COLORS.blocked}`,
        label: 'Invalid',
      };
    default:
      return {
        classes: `${baseClasses} bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300`,
        label: status || 'Unknown',
      };
  }
};

/**
 * Get power status color classes
 * @param {string} statusCode - Power status code (E, F, J, etc.)
 * @returns {string} Tailwind classes
 */
export const getPowerStatusColor = (statusCode) => {
  return STATUS_COLORS[statusCode] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

/**
 * Format file size for display
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted size string
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};
